import React from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';

import styled from 'styled-components';

import {
  NitroSingleSelect,
  NitroIcon,
  NitroTextField,
  NitroText
} from 'nitro-components';

import FilterConnectorIndicator from './FilterConnectorIndicator';

import { RULES, OPERATORS, FilterTypeMap } from '../Helpers';

import { OpenText } from '../../FilterTypes';

const FilterContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;

  > * {
    margin: 0 10px;
  }
`;

const FieldSelector = styled.div`
  flex: 1;
`;

const DeleteButton = styled.button`
  border: 0;
  outline: 0;
  background: none;

  visibility: ${props => (props.isDisabled ? 'hidden' : 'visible')};
`;

const FilterTypeComponentContainers = styled.div`
  min-width: 180px;
`;

class FilterComponent extends React.Component {
  constructor(props) {
    super(props);

    const filterFields = props.reportFilters.map(rf => {
      return {
        label: rf.title,
        value: rf.id
      };
    });

    this.state = {
      filterFields,
      filterOps: []
    };
  }

  onChange = newFilter => {
    const ftype = this.filterType({ field: newFilter.field });
    const filter = Object.assign(
      {},
      { type: ftype.componentType, componentType: ftype.componentType },
      newFilter
    );

    this.props.onChange(this.props.index, filter);
  };

  changeOperater = ({ value }) => {
    this.onChange({ ...this.props.filter, rule: value });
  };
  changeCondition = ({ value }) => {
    this.onChange({ ...this.props.filter, operator: value });
  };
  changeField = ({ value }) => {
    // blow out old filter value, label, operator and reset to
    // default filter options on filter selector change
    const { filter } = this.props;

    const { label, operator, type, componentType, ...rest } = filter;

    this.onChange({
      ...rest,
      field: value,
      value: null,
      operator: 0
    });
  };

  changeValue = value => {
    this.onChange({ ...this.props.filter, ...value });
  };

  filterType = filter => {
    const filterType = this.props.reportFilters.find(
      rf => rf.id === filter.field
    );
    return filterType;
  };

  removeFilter = () => {
    this.props.removeFilter(this.props.index);
  };

  render() {
    const {
      filter,
      reportFilters,
      isLastFilter,
      isFirstFilterGroup,
      index
    } = this.props;

    const { filterFields } = this.state;

    const isDefaultFilter = isFirstFilterGroup && index === 0;

    if (filterFields.length > 0 && filter.field === null)
      filter.field = filterFields[0].value;

    const filterOps = [];
    const filterType = this.filterType(filter);

    OPERATORS.forEach(op => {
      if (!filterType) return false;

      const validOps = FilterTypeMap[filterType.componentType].operators;
      if (!validOps.includes(op.value)) return;

      if (filter.operator === op.value) {
        op.selected = true;
      }

      filterOps.push(op);
    });

    if (filterOps.length > 0) filter.operator = filterOps[0].value;

    const FilterTypeComponent =
      filterType && filterType.componentType
        ? FilterTypeMap[filterType.componentType].component
        : OpenText;

    const mergedFilter = {
      ...filterType,
      ...filter,
      value: filter.value ? filter.value : filterType.value
    };

    return (
      <div>
        <FilterContainer>
          <NitroSingleSelect
            mandatory
            options={RULES}
            value={filter.rule}
            action={this.changeOperater}
          />

          <NitroText variant="base2" size="3">
            results within
          </NitroText>

          <FieldSelector>
            <NitroSingleSelect
              mandatory
              options={filterFields}
              value={filter.field}
              action={this.changeField}
            />
          </FieldSelector>

          <FieldSelector>
            <NitroSingleSelect
              mandatory
              options={filterOps}
              value={filter.operator}
              action={this.changeCondition}
            />
          </FieldSelector>

          <FilterTypeComponentContainers>
            <FilterTypeComponent
              mandatory
              filter={mergedFilter}
              action={this.changeValue}
            />
          </FilterTypeComponentContainers>

          <DeleteButton
            onClick={this.removeFilter}
            isDisabled={isDefaultFilter}
          >
            <NitroIcon name="delete" variant="base3" size={14} />
          </DeleteButton>
        </FilterContainer>
        {!isLastFilter && (
          <FilterConnectorIndicator label="OR" layout="horizontal" />
        )}
      </div>
    );
  }
}

FilterComponent.propTypes = {
  index: PropTypes.number,
  isLastFilter: PropTypes.bool,
  filter: PropTypes.object,
  onChange: PropTypes.func,
  removeFilter: PropTypes.func
};

const mapStateToProps = state => {
  const { reportFilters } = state.reports;

  return { reportFilters };
};

export default connect(mapStateToProps)(FilterComponent);



// WEBPACK FOOTER //
// ./src/features/scheduling-reports/new-report/Filters/components/FilterComponent.js